'use client';
import { Sidebar } from '@/components/sidebar';
import { CurrentWorkflowBanner } from '@/components/workflows/current-workflow-banner';
import { WorkflowProvider } from '@/providers/workflow-provider';

export default function DashboardLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <WorkflowProvider>
      <main className='relative flex max-h-window-keeper-height w-screen max-w-screen overflow-hidden'>
        <Sidebar variant='dashboard' />
        <section className='relative max-h-window-keeper-height w-full overflow-x-hidden overflow-y-auto'>
          <CurrentWorkflowBanner />
          {children}
        </section>
      </main>
    </WorkflowProvider>
  );
}
